import React from 'react';
import PropTypes from 'prop-types';
import { useIsMobile } from 'utils/hooks';
import { ProcessingBlock, Dialog, Div } from 'components/Ui';
import { ThumbUpGreen } from 'images';
import styles from './styles.scss';

const PromotionAppliedDialog = ({ open, setStatus, promotionLoading }) => {
  const isMobile = useIsMobile();
  return (
    <Dialog
      size="large"
      fullScreen={isMobile}
      isAutoClose
      autoCloseTimeout={3000}
      isCloseIcon={isMobile}
      open={open}
      onClose={setStatus}
    >
      <div className={styles.container}>
        {promotionLoading ? (
          <div
            className={!isMobile ? styles.subContainer : styles.mobileContainer}
          >
            <div className={styles.processingContainer}>
              <ProcessingBlock />
            </div>
          </div>
        ) : (
          <div
            className={!isMobile ? styles.subContainer : styles.mobileContainer}
          >
            <div className={styles.imageContainer}>
              <img src={ThumbUpGreen} alt=""></img>
            </div>{' '}
            <Div className={styles.textContainer}>
              {'Promotion has been applied!'}
            </Div>
          </div>
        )}
      </div>
    </Dialog>
  );
};

PromotionAppliedDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setStatus: PropTypes.func.isRequired,
  promotionLoading: PropTypes.bool.isRequired,
};

export default PromotionAppliedDialog;
